import { type IApiResponse, type IGetElectionTypeStates } from '@/helpers/types';
import { type IGetQuery } from '@/store/actions/api-utils';

import { coreApiSlice } from '../apiSlice';

const electionTypeApiSlice = coreApiSlice.injectEndpoints({
	endpoints: (builder) => ({
		createElectionType: builder.mutation<IApiResponse, { name: string }>({
			query: (body) => ({
				url: '/ElectionType',
				method: 'POST',
				body,
			}),
		}),
		getElectionType: builder.query<IApiResponse<IGetElectionTypeStates[]>, IGetQuery>({
			query: () => ({
				url: '/ElectionType',
			}),
		}),
		getElectionTypeById: builder.query<IApiResponse<IGetElectionTypeStates>, { id: string }>({
			query: ({ id }) => ({
				url: `/ElectionType/${id}`,
			}),
		}),
		updateElectionType: builder.mutation<IApiResponse, { id: string; data: { name: string } }>({
			query: ({ id, data }) => ({
				method: 'PUT',
				url: `/ElectionType/${id}`,
				body: data,
			}),
		}),
		deleteElectionType: builder.mutation<IApiResponse, { id: number }>({
			query: ({ id }) => ({
				url: `/ElectionType/${id}`,
				method: 'DELETE',
			}),
		}),
	}),
});

export const {
	useCreateElectionTypeMutation,
	useDeleteElectionTypeMutation,
	useGetElectionTypeByIdQuery,
	useLazyGetElectionTypeByIdQuery,
	useGetElectionTypeQuery,
	useUpdateElectionTypeMutation,
} = electionTypeApiSlice;
